import { Injectable } from '@angular/core';
import { ApiConnectorService } from '../__api/api-connector.service';
import { FunctionsService } from '../__common/functions.service';
import { GuiFlowService } from '../__gui/gui-flow.service';

@Injectable({
  providedIn: 'root'
})
export class CrudFieldsDataService {

  //REFACTOR
  crudsCache = { 
    cruds: []
  };

  successOnLastCreate = false;

  constructor(private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,private apiConnector: ApiConnectorService) { }

  // REFACTOR
  registerCrud(newCrud){
    if(newCrud && newCrud.id){
      newCrud.crudStatus = 'read';
      newCrud.currentObj = {};
      newCrud.editingModeObj = [];
      newCrud.showCreateUpdateButtons = true
    }else{
      this.turnEditionModeOff();
      let newCrudObj = {
        id: this.commonFunctions.generateRandomNumber(),
        tableName: newCrud.tableName? newCrud.tableName : null,
        table1: newCrud.table1? newCrud.table1 : null,
        table2: newCrud.table2? newCrud.table2 : null,
        tableX: newCrud.tableX? newCrud.tableX : null,
        queryName: newCrud.queryName? newCrud.queryName : null,
        FK_1: newCrud.FK_1? newCrud.FK_1 : null,
        FK_2: newCrud.FK_2? newCrud.FK_2 : null,
        hiddenInputFields: newCrud.hiddenInputFields.length>0? newCrud.hiddenInputFields : [],
        crudStatus: 'read',
        currentObj: {},
        editingModeObj: [],
        showCreateUpdateButtons: true,
      };
      newCrud = newCrudObj;
    } 
    this.crudsCache.cruds.push(newCrud);
    return newCrud;
  }

  turnEditionModeOff(){
    for(let crud of this.crudsCache.cruds){
      for(let inputField of crud.editingModeObj){
        inputField.editingMode = false;
      }
    }
  }

  getCrudStatus(crudId){
    let obj = this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)];
    if(obj){
      return obj.crudStatus;
    }
    console.log('unable to retrieve crud status : @crudFieldsDataService -> getCrudStatus()'  );
    return null;
  }

  setCurrentStatus(status,crudId){
    this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['crudStatus'] = status;
  }

  getQueryProps(crudId){
    return this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['tableProperties'];
  }

   createNewFKObject(crudConfiguration,httpOp){
    crudConfiguration.currentObj? null : this.setCurrentObject (crudConfiguration.id,this.getCurrentObj(crudConfiguration.id));
    if(this.isFormValid(crudConfiguration)){
      this.guiFlow.openLoadingModal();
      this.apiConnector.newDynamicApiRequest(httpOp, crudConfiguration.tableName, this.getCurrentObj(crudConfiguration.id))
        .subscribe(
          (response) => {
            this.processFKCreate(response,crudConfiguration);
            
            this.cleanObjects(crudConfiguration.id);
            this.guiFlow.closeLoadingModal();
          },
          (error) => {
            this.guiFlow.reportError(error,'crud-fields-data.service');
            this.guiFlow.closeLoadingModal();
          }
        );
    }else{
      this.guiFlow.reportError('Fill in mandatory fields',null);
    }
  }

  processFKCreate(response: any,crudConfig){
    if(response.OK && response.OK.records && response.OK.records.id){
      /* this.guiFlow.openSimpleSnackBar('Success inserting '+ crudConfig.tableName  +' item ✅', null); */
      this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudConfig.id)]['lastInserted'] = response.OK.records;
      this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudConfig.id)].list = [];
      this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudConfig.id)].list.push(response.OK.records)
      console.log('Success inserting '+ crudConfig.tableName  +' item ✅');
      this.insertFk_values(response.OK.records.id,crudConfig);
      this.getProperties(crudConfig.cacheLabel,crudConfig.id);
    }else{
      this.guiFlow.openSimpleSnackBar('Id of inserted element missing ⚠️', null);
    }
  }

  setCurrentObject(crudId,obj){
    this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['currentObj']=obj;
  }

  insertFk_values(lastInsertedId,crudConfig){
    let FK_Object = {};
    FK_Object[crudConfig.FK_1] = crudConfig.currentId;
    FK_Object[crudConfig.FK_2] = lastInsertedId;
    this.setCurrentObjectToUpdate(crudConfig.id,FK_Object); 
    this.apiConnector.newDynamicApiRequest('post', crudConfig.tableX, this.getCurrentObj(crudConfig.id))
    .subscribe(
      (response) => {
        /* this.guiFlow.openSimpleSnackBar('Success inserting FKs 🔑', null); */
        this.guiFlow.openSimpleSnackBar('Success inserting '+ crudConfig.tableName  +' item ✅', null);
        console.log('Success inserting FKs');
        this.successOnLastCreate = true;
        crudConfig.crudStatus = 'read';
      },
      (error) => {
        this.guiFlow.openSimpleSnackBar('ERROR inserting '+ crudConfig.tableName  +' item', null);
      }
    );
  }

  getCurrentObj(crudId){
    if(this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId) != -1){
      return this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['currentObj'];
    }
    else{
      return null;
    }
  }

  cleanObjects(crudId){
    this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['currentObj'] = {};
  }

  getProperties(cacheLabel,crudId){
    console.log('>>> GET Props: '+cacheLabel+'  crudId:'+crudId);
    this.apiConnector.executeApiRequest(cacheLabel,null,null,null,cacheLabel,false)
      .subscribe(response => this.saveDataAndProps(response,crudId));
  }

  saveDataAndProps(res,crudId){
    this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['tableProperties'] = res.props;
  }

  setCurrentObjectToUpdate(crudId,obj){
    this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['currentObj'] = obj;
  }

  isFormValid(crudConfig){
    for(let field of crudConfig.mandatoryFields){
      if(crudConfig.currentObj && !crudConfig.currentObj[field]){
        return false;
      }
    }
    return true;
  }

  createNewObject(crudConfiguration){
    crudConfiguration.currentObj? null : this.setCurrentObject (crudConfiguration.id,this.getCurrentObj(crudConfiguration.id));
    if(crudConfiguration.fixedValues && crudConfiguration.fixedValues.length>0){
      for(let fv of crudConfiguration.fixedValues){
        crudConfiguration.currentObj[fv.columnName] = fv.value;
      }
    }

    this.apiConnector.newDynamicApiRequest('post', crudConfiguration.tableName, this.getCurrentObj(crudConfiguration.id))
    .subscribe(
      (response) => {
        if(response){
          if(response && response.KO){
            this.guiFlow.reportError(response.KO.message,'crud-fields-data.service');
          }else{
            this.processCreate(crudConfiguration);
            this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudConfiguration.id)]['lastInserted'] = response.OK.records.id;
            this.setCurrentObject (crudConfiguration.id,response.OK.records);
            this.cleanObjects(crudConfiguration.id);
          }
        }else{
          this.guiFlow.reportError('No response received','crud-fields-data.service');
        }
      },
      (error) => {
        this.guiFlow.reportError(error,'crud-fields-data.service');
      }
    );
  }

  processCreate(crudConfig){
    this.guiFlow.openSimpleSnackBar('Created successfully 🤟', 'success');
    this.turnEditionModeOff();
    this.setCurrentStatus('read',crudConfig.id);
  }

  updateObject(crudConfiguration,httpOp){
    debugger;
    let firstTableObject = this.getObjectFields();
    this.apiConnector.newDynamicApiRequest(httpOp, crudConfiguration.tableName, this.getCurrentObj(crudConfiguration.id))
    .subscribe(
      (response) => {
       /*  this.processFKCreate(response,crudConfiguration);
        this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudConfiguration.id)]['lastInserted'] = response.OK.records;
        this.cleanObjects(crudConfiguration.id); */
        
      },
      (error) => {
        this.guiFlow.reportError(error,'crud-fields-data.service');
      }
    );
  }

  getObjectFields(){
    let obj = {};
  }

  addValueToFieldInObj(field, value,crudId){
    // TO DO delete y read
    /* switch(this.guiFlow.getCurrentState()){ */
    let obj = this.getCurrentObj(crudId);
    obj[field] = value;
    this.setCurrentObject(crudId,obj);
  }

  getCurrentObjectToUpdate(crudId){
    // TODO
/*     if(this.isCurrentStatus('create',crudId)){
      this.cleanObjects();
    } */
    return this.getCurrentObj(crudId);
  }

  isCurrentStatus(status,crudId){
    return this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)]['crudStatus'] === status;
  }

  getLastInsertedObj(crudId){
    let obj = this.crudsCache.cruds[this.commonFunctions.searchForObjectInArrayByCrudId(this.crudsCache.cruds,crudId)];
    return JSON.stringify(obj.lastInserted);
  }
}
